import React, { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "@/redux/api";
import { useAuthEditable } from "@/hooks/use-auth";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import {
  WORKORDER_CREATE_PREFILL_KEY,
  writeFlowPrefill,
} from "@/utils/flow-prefill";
import ContractDetail from "@/containers/contract/ContractDetail";

export default function FacilityContractDetailPage() {
  const { companyId, facilityId, id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const canAddNote = useAuthEditable("contract");
  const baseListPath = buildFacilityPath("contract-request", facilityContext) || "/switch-view";
  const listPath = `${baseListPath}${location.search || ""}`;

  const loadRequest = useCallback(
    (requestId) => api.getContract(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, body) => api.addContractNote(requestId, body),
    []
  );
  const getWorkorderPath = useCallback(
    (record) =>
      buildFacilityPath(`workorder-detail/${record.workorder_id}`, { companyId, facilityId }) || "/switch-view",
    [companyId, facilityId]
  );
  const createWorkorder = useCallback(
    (record) => {
      const createPath = buildFacilityPath("create-workorder", { companyId, facilityId });
      if (!createPath || !record) return;
      writeFlowPrefill(WORKORDER_CREATE_PREFILL_KEY, {
        sourceLabel: `Contract Request #${record.id}`,
        contract_request: record.id,
        service_request: record.service_request_id || null,
        facility: record.facility,
        equipment: record.equipment || null,
        service_category: record.service_category || null,
        issue: record.title || "",
        description: record.description || "",
        priority: record.priority || null,
        due_date: record.due_date || null,
        estimate_budget: record.estimate_budget ?? null,
        contractor: record.assignTo || null,
      });
      navigate(createPath);
    },
    [companyId, facilityId, navigate]
  );

  return (
    <ContractDetail
      role="facility"
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote={canAddNote}
      closeContract={api.closeContract}
      award={api.awardContract}
      createWorkorder={createWorkorder}
      getWorkorderPath={getWorkorderPath}
    />
  );
}
